import React from 'react';
import SolutionRequestEstimateLedContainer from 'containers/SolutionRequestEstimateLedContainer/SolutionRequestEstimateLedContainer';

export default function SolutionRequestEstimateLedPage() {
    return (
        <SolutionRequestEstimateLedContainer />
    )
}
